import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from '@cargomatic/ui';
export function LegNavigation({ currentLeg, totalLegs, onLegChange, }) {
    return (React.createElement("div", { className: "flex items-center gap-4" },
        React.createElement("h1", { className: "text-xl font-semibold text-foreground" },
            "Leg ",
            currentLeg,
            " of ",
            totalLegs),
        totalLegs > 1 && (React.createElement("div", { className: "flex items-center gap-2" },
            React.createElement(Button, { variant: "outline", size: "icon", onClick: () => onLegChange(Math.max(1, currentLeg - 1)), disabled: currentLeg === 1, className: "h-8 w-8" },
                React.createElement(ChevronLeft, { className: "h-4 w-4" })),
            React.createElement(Select, { value: currentLeg.toString(), onValueChange: (value) => onLegChange(Number.parseInt(value)) },
                React.createElement(SelectTrigger, { className: "w-[100px] h-8" },
                    React.createElement(SelectValue, null)),
                React.createElement(SelectContent, null, Array.from({ length: totalLegs }, (_, i) => i + 1).map((leg) => (React.createElement(SelectItem, { key: leg, value: leg.toString() },
                    "Leg ",
                    leg))))),
            React.createElement(Button, { variant: "outline", size: "icon", onClick: () => onLegChange(Math.min(totalLegs, currentLeg + 1)), disabled: currentLeg === totalLegs, className: "h-8 w-8" },
                React.createElement(ChevronRight, { className: "h-4 w-4" }))))));
}
